import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/set-d2c.png'
import _imports_1 from '@/assets/image/set-b2b.png'


const _withScopeId = n => (_pushScopeId("data-v-1b90c1ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "order-number-point"
}
const _hoisted_2 = { class: "order-list-table" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1708487696284",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6832",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 74.688C270.912 74.688 74.688 270.912 74.688 512c0 241.088 196.224 437.312 437.312 437.312 241.088 0 437.312-196.224 437.312-437.312 0-241.088-196.224-437.312-437.312-437.312z m0 810.624C307.2 885.312 138.688 716.8 138.688 512S307.2 138.688 512 138.688 885.312 307.2 885.312 512 716.8 885.312 512 885.312zM469.312 320a42.688 42.688 0 1 0 85.376 0 42.688 42.688 0 0 0-85.376 0zM512 437.312c-17.088 0-32 14.976-32 32V704c0 17.088 14.912 32 32 32s32-14.912 32-32V469.312c0-17.024-14.912-32-32-32z",
    "p-id": "6833",
    fill: "#ffffff"
  })
], -1))
const _hoisted_7 = { style: {"margin-left":"4px"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"width":"200px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-wenhao1",
  style: {"font-size":"14px","cursor":"pointer"}
}, null, -1))
const _hoisted_11 = { class: "flex-col pay-info" }
const _hoisted_12 = { class: "pay-info-list" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { style: {"font-weight":"600"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_19 = {
  key: 0,
  style: {"font-weight":"600"}
}
const _hoisted_20 = {
  key: 1,
  style: {"font-weight":"600"}
}
const _hoisted_21 = {
  key: 2,
  style: {"font-weight":"600"}
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { style: {"font-weight":"600"} }
const _hoisted_24 = { style: {"font-weight":"600"} }
const _hoisted_25 = { style: {"font-weight":"600"} }
const _hoisted_26 = {
  key: 0,
  class: "pay-info-list"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "flex-bwn" }
const _hoisted_29 = {
  key: 0,
  class: "list-dec mr_5"
}
const _hoisted_30 = {
  key: 0,
  class: "paid"
}
const _hoisted_31 = {
  key: 1,
  class: "cur-pay"
}
const _hoisted_32 = {
  key: 2,
  class: "unPaid"
}
const _hoisted_33 = { class: "order-child-table" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { key: 3 }
const _hoisted_53 = { class: "flexcenter" }
const _hoisted_54 = { style: {"flex":"1"} }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { key: 2 }
const _hoisted_58 = { class: "flex-ter" }
const _hoisted_59 = { class: "word-break-en" }
const _hoisted_60 = {
  style: {"width":"200px"},
  class: "word-break-en"
}
const _hoisted_61 = {
  key: 0,
  class: "line--2 word-break-en"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 2 }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  style: {"width":"200px"},
  class: "word-break-en"
}
const _hoisted_66 = { class: "line--2 word-break-en" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 2 }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 3,
  class: "addition-tip-jp"
}
const _hoisted_71 = { class: "flex-ter" }
const _hoisted_72 = {
  key: 1,
  class: "flex-ter"
}
const _hoisted_73 = {
  key: 2,
  referrerPolicy: "no-referrer",
  src: _imports_0,
  style: {"margin-left":"10px","width":"50px"},
  class: "order-tag"
}
const _hoisted_74 = ["src"]
const _hoisted_75 = {
  key: 4,
  referrerPolicy: "no-referrer",
  src: _imports_1,
  style: {"margin-left":"10px","width":"50px"},
  class: "order-tag"
}
const _hoisted_76 = ["src"]
const _hoisted_77 = { class: "flexcenter" }
const _hoisted_78 = { style: {"flex":"1"} }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { key: 2 }
const _hoisted_82 = { class: "flex-ter" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "word-break-en" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { key: 1 }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 0,
  class: "quantity-input-number"
}
const _hoisted_92 = { key: 1 }
const _hoisted_93 = {
  style: {"width":"200px"},
  class: "word-break-en"
}
const _hoisted_94 = { class: "line--2 word-break-en" }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 2 }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { style: {"text-align":"center"} }
const _hoisted_99 = { class: "flexcenter" }
const _hoisted_100 = { class: "flex-ter" }
const _hoisted_101 = ["src"]
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { key: 2 }
const _hoisted_104 = /*#__PURE__*/_createTextVNode("複数倉庫出荷（自動分割）")
const _hoisted_105 = {
  key: 2,
  class: "tag-content"
}
const _hoisted_106 = { class: "replenish-tag" }
const _hoisted_107 = { class: "flexcenter mb_5" }
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { class: "flexcenter" }
const _hoisted_110 = { class: "word-break-en" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { key: 2 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_116 = { key: 1 }
const _hoisted_117 = {
  class: "flex-bwn-wrap",
  style: {"padding":"4px 0","width":"100%"}
}
const _hoisted_118 = { class: "tooltip-wrap" }
const _hoisted_119 = { class: "header flex -bwn" }
const _hoisted_120 = { class: "title" }
const _hoisted_121 = { class: "content mt_5" }
const _hoisted_122 = ["innerHTML"]
const _hoisted_123 = { key: 1 }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_127 = ["onClick"]
const _hoisted_128 = { key: 1 }
const _hoisted_129 = /*#__PURE__*/_createTextVNode(" 订单发货国家 ")

import UnRechargeModal from '@/components/UnRechargeModal/index.vue'
import UnBalanceConfirm from '@/components/UnBalanceConfirm/index.vue'
import { t } from '@/plugins/i18n'
import {
  ref,
  toRaw,
  computed,
  reactive,
  watch,
  getCurrentInstance,
  nextTick,
  onMounted,
  onUnmounted
} from 'vue'
import {
  QuestionFilled,
  Close,
  Warning,
  CircleClose
} from '@element-plus/icons-vue'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import GoodsLink from '@/components/common/GoodsLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import SSearch from './Search.vue'
import ApplyCancelDialog from '../components/ApplyCancelDialog/index.vue'
import DeliveryPriorityDialog from '../components/DeliveryPriorityDialog/index.vue'
import AfterSalesDialog from '../components/AfterSalesDialog/index.vue'
import RepurchaseDialog from '../components/RepurchaseDialog/index.vue'
import BDialog from './BDialog.vue'
import CombinationDialog from '../components/CombinationDialog.vue'
import ProductStats from '../components/ProductStats.vue'
import DocumentaryRecord from '../components/DocumentaryRecord.vue'
import ProductSku from '../components/ProductSku.vue'
import Guide from '@/components/guide/index.vue'
import FinalPriceDialog from '../components/FinalPriceDialog.vue'
import DeliAdt from '@/components/additional/DeliAdt.vue'
import CommonTip from '@/components/CommonTip/index.vue'
import BatchDeliveryDialog from './BatchDeliveryDialog.vue'
import ExpressSelect from '@/components/ExpressSelect/index.vue'
import { countryCodeNameMap, jpWareInfo, ShopType } from '@/common/const'
import AllPriceDetail from '@/views/shopcart/components/choice/AllPriceDetail.vue'

import Recharge from '@/views/shopcart/components/choice/Recharge.vue'
import CreateOrderSuccess from '@/views/shopcart/components/choice/CreateOrderSuccess.vue'
import Tipstishi from '@/components/IconPark/Tipstishi.vue'
import NoStockModal from '@/views/shopcart/components/NoStockModal.vue'
import {
  getPlatformOrder,
  getPlatformOrderItem,
  getPlatformOrderItemPage,
  postPlatformOrderPay,
  priorityShipping,
  orderRepurchase,
  editDeliveryAdditionsApi,
  editIntShipApi,
  editOrderGoodsAdditionApi,
  getEveryOrderNumberApi,
  isShowShopifyTitleApi,
  partPayApi,
  editCustomerNoApi,
  batchPriorityShipping,
  existPriorityShippingJobApi,
  getPlatformOrderDetail,
  editTransportTypeApi
} from '@/apis/order'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import { getJapanTime, getTrueNumber } from '@/util/common'
import { showCurrentUnit, showPriceAndUnit, allIncludeExchangeRate } from '@/util/useYan'
import { COUNTRY } from '@/global'
import { ElMessage, ElMessageBox } from 'element-plus'
import { normal } from '@/util/useConfirm'
import { canDeliveryPriority } from '../components/DeliveryPriorityDialog/data'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import {
  d2cOrderColumns,
  b2bOrderColumns,
  b2bChildColumns,
  d2cChildColumns,
  tableConfig,
  childConfig,
  d2cOrderTabs,
  b2bOrderTabs,
  childApiConfig,
  orderSourceEnum,
  platformOrderTypeEnum,
  channelEnum,
  combinationStatusDict,
  settlementStatus,
  d2cChoiceChildColumns
} from './data'
import useTable from './useTable'
import useTabData from '@/util/useTabData'
import useFilter from './useFilter'
import { isD2C, useRtfix, useSite2Station, getCustomerShopPlatform, useSite, isKO, isMultiStore, getWarehouseCode, isJA, getWarehouseByCountry, is3RDCustomerShop } from '@/store'
import axios from 'axios'
import { useStore } from 'vuex'
import { exportFileDownload } from '@/util/useExport'
import { setProdcutLink } from '../data'
import { cancelProgressDict } from '../AbnormalOrder/data'
import CopyButton from '@/components/common/CopyButton.vue'
import { setTimeout } from 'timers'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import { useRoute, useRouter } from 'vue-router'
import { getUser } from '@/apis/login'
import { intShipConfigList } from '@/apis/inShipping'
import { searchUploadProgressApi } from '@/apis/shopcart'
import UploadFail from '@/views/shopcart/components/UploadFail.vue' // 下单失败弹窗
import PartPayDialog from '../components/PartPayDialog.vue'
import BalanceDialog from '../components/BalanceDialog.vue'
import ExpressDrawer from '../components/ExpressDrawer.vue'
import DrawerDocumentaryRecord from '../components/DrawerDocumentaryRecord.vue'
import { isArray } from 'lodash'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import EchartBtn from '@/components/common/EchartBtn.vue'
import {
  montageAddition,
  isConfirmWashAdditionCustomerSku
} from '@/util/calcAdt'
import { getWallet, throughCountryGetExpressApi } from '@/apis/user'
import useEchart, { getVisitorTicketListResult, VisitorTicketListResultItem } from '@/util/useEchart'
import { showModal } from '../ConfirmOrder'
import SelectTransport from '@/components/selectTransport/index.vue'
import { request } from '@/config/request/interceptors'
import { getCustomerWalletList, getUnCheckMoney } from '@/apis/fund'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const unBalanceConfirmRef = ref()
const currentUnit = ref('')
const route = useRoute()
const router = useRouter()
const imgHeader =
  'https://static-s.theckb.com/BusinessMarket/Client/fund/split-'
const expressDrawerVisible = ref(false)
const {
  STableRef,
  pageData,
  refreshTable,
  SChildTableRefs,
  handleExpandRow,
  handleExpandAll,
  selectedOrderList,
  expandList,
  handleSelectionChange,
  toggleExpandAllChange,
  changeSelectFn,
  selectPageOption
} = useTable()
const showAdt = ref(false)
const deliveryAdditionalList = ref([])
const { tabData, platformOrderStatus } = useTabData(
  { TabName: 'platformOrderStatus' },
  () => {
    refreshTable(true)
    setOrderNum()
  }
)

const isTiktok = computed(() => store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK && isD2C())
const { language, metaData, companyId } = useEchart()
let timer: NodeJS.Timeout | null = null
const echartRecordList = ref<VisitorTicketListResultItem[]>([])

onMounted(() => {
  const getEchartRecord = async () => {
    const res: getVisitorTicketListResult = (await axios.get(`https://eapi.echatsoft.com/getVisitorTicketList?metaData=${encodeURIComponent(metaData)}&companyId=${companyId}`)).data
    console.log(res)
    if (res.successful) {
      echartRecordList.value = res.result
      console.log(echartRecordList.value, 'echartRecordList')
    }
  }
  if (isJA()) {
    getEchartRecord()
    timer = setInterval(getEchartRecord, 5000)
  }
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})

/** 批量优先发货弹窗 */
const batchDeliveryModal = ref()

/** 批量优先发货 */
const batchPriorityDelivery = async () => {
  //   如果选择优先发货不为是，则需要提示
  if (orderForm.value.preferDeliverFlag !== '1') {
    ElMessage({
      dangerouslyUseHTMLString: true,
      message: t('请将优先发货筛选项改为是后操作'),
      type: 'warning'
    })
    return
  }
  const data = await existPriorityShippingJobApi()
  //   再次点击时需要判断是否有已经开始的任务
  if (data.data) {
    ElMessage({
      message: t('已经存在提前发货任务'),
      type: 'warning'
    })
    return
  }
  batchDeliveryModal.value.open()
}
/** 批量优先发货-确认 */
const confirmBatchPriorityDelivery = async () => {
  const platformOrderNos = selectedOrderList.value?.map(
    (item) => item.platformOrderNo
  )
  try {
    const res = await batchPriorityShipping({
      platformOrderNos: platformOrderNos
    })
    if (!res?.success) {
      //   ElMessage.error(t('批量优先发货失败'))
      return
    }
    ElMessage({
      message: t('批量优先发货中，请稍等1-3分钟，期间请勿重复操作'),
      type: 'warning'
    })
    // 刷新列表(直接刷新整个页面)
    window.location.reload()
    // search()
  } catch (error) {
    // ElMessage.error(t('批量优先发货失败'))
  }
}

const refreshInfo = () => {
  refreshTable(true)
  setTimeout(() => {
    setOrderNum()
  }, 3000)
}
const exportNum = computed(() => {
  let list: any = []
  for (const k in selectPageOption.value) {
    list = [
      ...list,
      ...selectPageOption.value[k].map((e: any) => e.platformOrderId)
    ]
  }
  return list.length
})
const getImage = (val: string) => {
  return val?.split(',')?.[0]
}
const { orderForm, filterData } = useFilter(platformOrderStatus)
if (route.query.platformOrderNo) {
  const platformOrderNo: any = route.query.platformOrderNo
  orderForm.value.platformOrderNoList = platformOrderNo?.split(',')
}
const rowItem: any = ref({})
const dataList: any = ref([])
// 国际物流列表
const logisticsList: any = ref([])
intShipConfigList({
  systemSource: isD2C() ? 1 : 2,
  stationCode: useSite2Station()
}).then((res: any) => {
  if (res.success) {
    logisticsList.value = res.data
  }
})
const getOrderItem = () => {
  return new Promise<void>((resolve) => {
    getPlatformOrderItem({
      platformOrderId: rowItem.value.platformOrderId,
      source: 2
    })
      .then(async (res: any) => {
        if (res.success) {
          dataList.value = res.data.map(v => ({
            ...v,
            isReplenish: rowItem.value?.tags.includes(7)
          }))
        }
      })
      .finally(() => {
        resolve()
      })
  })
}

const afterSaleVisible = ref(false)
const afterSale = async (row: any) => {
  rowItem.value = toRaw(row)
  row.afterSaleLoading = true
  await getOrderItem()
  row.afterSaleLoading = false
  if (!dataList.value.length) return ElMessage.warning(t('该订单无法进行售后'))
  afterSaleVisible.value = true
}

const deliveryPriorityVisible = ref(false)
const deliveryPriority = async (row: any) => {
  rowItem.value = toRaw(row)
  row.deliveryPriorityLoading = true
  await getOrderItem()
  row.deliveryPriorityLoading = false
  if (!dataList.value.length) { return ElMessage.warning(t('没有可优先发货的商品')) }
  const flag = dataList.value.some((v: any) => canDeliveryPriority(v) || v.isReplenish)
  if (!flag) return ElMessage.warning(t('没有可优先发货的商品'))
  if (dataList.value.length === 1) {
    normal(
      { msg: t('是否确认优先发货') },
      () => {
        priorityShipping(
          dataList.value.map((e: any) => ({
            platformOrderId: e.platformOrderId,
            platformOrderItemId: e.platformOrderItemId
          }))
        ).then((res2: any) => {
          if (res2.success) {
            ElMessage.success(t('优先发货成功'))
          }
        })
      },
      () => null
    )
    return
  }
  if (dataList.value.length > 1) {
    deliveryPriorityVisible.value = true
  }
}

const repurchaseCartVisible = ref(false)
const openRepurchaseCartVisible = async (row: any) => {
  rowItem.value = toRaw(row)
  row.repurchaseCartLoading = true
  await getOrderItem()
  row.repurchaseCartLoading = false
  if (!dataList.value.length) return ElMessage.warning(t('该订单无法复购'))
  if (dataList.value.length === 1) {
    normal(
      { msg: t('确认要追加商品吗？') },
      () => {
        orderRepurchase({
          platformOrderNo: rowItem.value.platformOrderNo,
          repurchaseType: 1,
          shopProductSkus: [dataList.value[0].shopProductSku]
        }).then((res2: any) => {
          if (res2.success) {
            ElMessage.success(t('复购成功'))
          }
        })
      },
      () => null
    )
    return
  }
  if (dataList.value.length > 1) {
    repurchaseCartVisible.value = true
  }
}

const applyCancelVisible = ref(false)
const applyCancel = async (row: any) => {
  rowItem.value = toRaw(row)
  row.applyCancelLoading = true
  await getOrderItem()
  row.applyCancelLoading = false
  // if (!dataList.value.length) return ElMessage.warning(t('没有可申请取消的商品'))
  // const flag = row.platformOrderType === 1
  //   ? dataList.value.some((v: any) => canApplyCancel(v))
  //   : dataList.value.some((v: any) => canStoreApplyCancel(v))
  // if (!flag) return ElMessage.warning(t('没有可申请取消的商品'))
  applyCancelVisible.value = true
}

const inVisible = ref(false)
const international = (row: any) => {
  rowItem.value = toRaw(row)
  inVisible.value = true
}

const combinationVisible = ref(false)
const openCombinationVisible = (row: any) => {
  rowItem.value = toRaw(row)
  combinationVisible.value = true
}

const exportLoading = ref(false)
const store = useStore()
const exportOrder = (type:number) => {
  // if (!selectedOrderList.value.length) return ElMessage.warning(t('请选择需要导出的订单'))
  let list: any = []
  for (const k in selectPageOption.value) {
    list = [
      ...list,
      ...selectPageOption.value[k].map((e: any) => e.platformOrderId)
    ]
  }
  const platformOrderIds = list.join(',')
  // return
  exportLoading.value = true
  axios({
    method: 'get',
    url:
      process.env.VUE_APP_URL +
      (type === 1 ? '/order/customer/platformOrderItem/exportOrderCommodityInfo' : '/order/customer/platformOrderItem/exportOrderCommodityInfo3rd'),
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-AuthShopId': store.getters.curShop,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC'
    },
    params: {
      platformOrderIds
    }
  })
    .then((res: any) => {
      exportFileDownload(res, { name: t('我的订单') })
    })
    .finally(() => {
      exportLoading.value = false
      refreshTable()
    })
}
const templateLevel = ref(store.getters.membership.templateLevel)
const isSub = store.getters.isSub
const token = store.getters.token
const popverIndex = ref(0)
const { proxy } = getCurrentInstance() as any
const goods = ref([])
const visible = ref(false)
const payRow = ref({})
const toPay = async (row: any, type?: number) => {
  await getBalance()
  payRow.value = row
  // 批量标志type
  getUser(token).then(async (res: any) => {
    if (res.success) {
      const apis = []
      templateLevel.value = res.data.membership.templateLevel
      // 无需校验会员
      const pass = true
      if (!pass && res.data.membership.templateLevel === 0) {
        if (type) {
          ElMessage.warning(t('尊敬的用户，您需办理会员后，方可下单'))
          return
        }
        STableRef.value.tableData.forEach((item: any) => {
          if (proxy.$refs[`memberPopver${item.platformOrderId}`]) {
            proxy.$refs[`memberPopver${item.platformOrderId}`].open = false
          }
        })
        popverIndex.value = row.platformOrderId
        // 关闭tips
        proxy.$refs[`memberPopver${row.platformOrderId}`].open = true
      } else {
        // 智能补货计划的待支付订单直接跳转待支付详情页
        if (row.tags.includes(7)) {
          router.push(
            useRtfix('ConfirmOrder', {
              query: {
                id: row.platformOrderId,
                sc: row?.deliveryCountry,
                isReplenish: 1
              }
            })
          )
          return
        }
        // 批量下单仅支持表格下单
        if (type) {
          router.push(
            useRtfix('ConfirmOrder', {
              query: {
                id: selectedOrderList.value
                  .map((item: any) => item.platformOrderId)
                  .join(','),
                sc: selectedOrderList.value[0]?.deliveryCountry
              }
            })
          )
          return
        }
        // 表格下单去支付跳转确认支付页confirmorder
        if (row.orderSource === 6) {
          router.push(
            useRtfix('ConfirmOrder', { query: { id: row.platformOrderId, sc: row.deliveryCountry } })
          )
          return
        }
        // 订单信息查询
        const res1 = await getPlatformOrderDetail({
          platformOrderId: row.platformOrderId
        })
        const OrderProductDetailList: any = []
        if (res1.success) {
          res1.data?.platformOrderItemList?.forEach((j: any) => {
            OrderProductDetailList.push({
              product_num: j.orderQuantity,
              product_title_ja: j.productTitleJp,
              product_code: j.productCode
            })
          })
        }
        if (row.orderSource === 10) {
          const noAdtItem = res1.data.platformOrderItemList.find(v => v.platformOrderItemAdditionDTOList === '-' && v.noAdditionalFlag !== 1)
          if (noAdtItem) {
            console.log(STableRef.value.isFilp(row))
            ElMessage.warning(t('附加项验证'))
            if (!STableRef.value?.isFilp(row)) {
              STableRef.value.expandRowChange(row)
            }
            return
          }
        }
        try {
          row.payLoading = true
          const res = await request.order.customer.platformOrderPay({
            platformOrderId: row.platformOrderId
          })
          if (res.success) {
            // 校验线下商品库存
            const { stockSkus, downSkus, validSkus, firstOrderFlag, meetFreeShipFlag } = res.data!
            if (stockSkus?.length) {
              getPlatformOrderItem({
                platformOrderId: row.platformOrderId,
                source: 2
              }).then((res: any) => {
                const list: any = []
                res.data.forEach((item: any) => {
                  if (
                    stockSkus.includes(item.productSku) &&
                    item.channel === 5
                  ) {
                    list.push({
                      ...item,
                      price: item.actualProductSellPrice
                    })
                  }
                })
                if (list.length === 0) {
                  taTrack({
                    event: TaEvent.ORDER_PAY,
                    value: {
                      currency: 'CNY',
                      order_no: row.platformOrderNo,
                      pay_amount: row.totalFreezeAmount,
                      pay_result: 'fail',
                      fail_reason: '',
                      order_product_detail: OrderProductDetailList
                    }
                  })
                  ElMessage.warning(t('支付失败'))
                  return
                }
                goods.value = list
                visible.value = true
              })
              return
            } else if (downSkus?.length || validSkus?.length) {
              taTrack({
                event: TaEvent.ORDER_PAY,
                value: {
                  currency: 'CNY',
                  order_no: row.platformOrderNo,
                  pay_amount: row.totalFreezeAmount,
                  pay_result: 'fail',
                  fail_reason: '',
                  order_product_detail: OrderProductDetailList
                }
              })
              ElMessage.warning(t('支付失败'))
              return
            }

            taTrack({
              event: TaEvent.ORDER_PAY,
              value: {
                currency: 'CNY',
                order_no: row.platformOrderNo,
                pay_amount: row.totalFreezeAmount,
                pay_result: 'success',
                fail_reason: '',
                order_product_detail: OrderProductDetailList
              }
            })

            if (isJA()) {
              localStorage.setItem('ckb_last_order_id', row.platformOrderId)
              if (firstOrderFlag) {
                window.location.href = `/order_complete_first?hasCoupon=${meetFreeShipFlag ? 1 : 0}`
              } else {
                window.location.href = '/order_complete'
              }
            } else {
              ElMessage.success(t('支付成功'))
              refreshTable()
            }
          } else {
            if (res.code === '22010002') {
              // 余额不足
              if (row.tags.includes(4)) {
                getPlatformOrderItem({
                  source: 1,
                  platformOrderId: row.platformOrderId
                }).then((res: any) => {
                  payGoodsList.value = res.data

                  rechargeRef.value.open()
                })
              } else {
                getCustomerWalletList({
                  stationCode: useSite2Station(),
                  currencyCode: row?.deliveryCountry === COUNTRY.KR ? 'KRW' : 'CNY'
                }).then(async (res: any) => {
                  const { data } = res
                  const recharge = data.find?.((e: any) => e.accountType === 1)?.availableAmount ?? 0
                  const unCheckCnyAmt = await getUnCheckMoney({ currencyCode: row?.deliveryCountry === COUNTRY.KR ? 'KRW' : 'CNY' }).then(res => {
                    return res.data.unCheckCnyAmt
                  })
                  if (recharge > 0 || unCheckCnyAmt > 0) {
                    bus.emit('openUnRechargeModal', {
                      currency: row?.deliveryCountry === COUNTRY.KR ? 'KRW' : 'CNY',
                      unCheckCnyAmt
                    })
                  } else {
                    unBalanceConfirmRef.value?.open()
                    // showModal(router)
                  }
                })
              }
            }
            if (res.code === '22010091') {
              ElMessage.warning(t('待支付的订单才能重新支付，请确认后重新选择'))
            }
            if (res.code === '260000001' && row.tags.includes(4)) {
              ElMessageBox.confirm(t('当前商品价格发生变化，请确认后决定是否下单'), t('提示'), {
                confirmButtonText: t('关闭2'),
                showCancelButton: false,
                showClose: false,
                type: 'warning'
              })
            }
            if (res.code === '240000055' && row.tags.includes(4)) {
              // 一口价订单价格变化时
              ElMessageBox.confirm(t('一口价订单金额发生变化，请重新确认'), t('提示'), {
                confirmButtonText: t('确定'),
                cancelButtonText: t('取消'),
                type: 'warning'
              })
              changeTransportType(row.platformOrderId, row.transportType)
            }
            taTrack({
              event: TaEvent.ORDER_PAY,
              value: {
                currency: 'CNY',
                order_no: row.platformOrderNo,
                pay_amount: row.totalFreezeAmount,
                pay_result: 'fail',
                fail_reason: res.msg,
                order_product_detail: OrderProductDetailList
              }
            })
          }
        } catch (error) {

        } finally {
          row.payLoading = false
        }
      }
    }
  })
}

const toPay2 = (row: any) => {
  STableRef.value.tableData.forEach((item: any) => {
    if (proxy.$refs[`memberPopver${item.platformOrderId}`]) {
      proxy.$refs[`memberPopver${item.platformOrderId}`].open = false
    }
  })
  popverIndex.value = row.platformOrderId
  proxy.$refs[`memberPopver${row.platformOrderId}`].open = true // 关闭tips
}

const closePopver = () => {
  proxy.$refs[`memberPopver${popverIndex.value}`].open = false // 关闭tips
}

const orderClassName = ({ row, rowIndex }: any) => {
  if (expandList.value && expandList.value.includes(row.platformOrderId)) {
    return 'expand-status'
  } else {
    return ''
  }
}
const tableData = computed(() => {
  return STableRef.value?.tableData || []
})

const finalStatus = ref(false)
const finalData = ref()
const checkFinalPrice = (row: any) => {
  finalData.value = row.settlePriceList
  currentUnit.value = showCurrentUnit(row.goodsCountry === COUNTRY.KR)
  finalStatus.value = true
}

const jump = (url: any) => {
  const routerUrl: any = router.resolve(url)
  window.open(routerUrl.href, '_blank')
}

const jumpCancel = (row: any, scope: any) => {
  const routerUrl: any = router.resolve(
    useRtfix('AbnormalOrder', {
      query: {
        abnormal: 'ApplyCancel',
        platformOrderNo2: scope.platformOrderNo,
        productSku: row.productSku,
        processManner: '1'
      }
    })
  )
  window.open(routerUrl.href, '_blank')
}
const dataListenerFn = (data: any) => {
  expandList.value = []
  changeSelectFn(data)
}
const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  if (params.productSkuList) {
    // 商品搜索
    router.push(
      useRtfix('OrderSearch', {
        query: { productSkuList: params.productSkuList.join(',') }
      })
    )
  }
  if (params.customerProductMskuList) {
    // 商品搜索
    router.push(
      useRtfix('OrderSearch', {
        query: {
          customerProductMskuList: params.customerProductMskuList.join(',')
        }
      })
    )
  }
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    customerShopId: filterData.value.customerShopId
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}

// 批量付款
const batchPay = () => {
  if (selectedOrderList.value.length === 0) {
    ElMessage.warning(t('请勾选订单'))
    return
  }
  let country = ''
  let isWarning = false
  selectedOrderList.value.forEach((i: { deliveryCountry: string }) => {
    if (!country) {
      country = i.deliveryCountry
      return
    }
    if (country !== i.deliveryCountry) {
      isWarning = true
    }
  })
  if (isWarning) {
    ElMessage.warning(t('请选择相同发货国家的订单'))
    return
  }
  toPay({}, 1)
}

const parentTableConfig = {
  ...tableConfig,
  // 待付款tab 只能勾选表格下单的订单 一价全包不支持批量支付
  selectable: (row: any) =>
    tabData.value !== '2' || (tabData.value === '2' && (row.orderSource === 6 || row.orderSource === 10) && !row.tags?.includes(4))

}
let waitOrderItem: any = {}
const openDt = (row: any) => {
  waitOrderItem = row
  // row.platformOrderDeliveryAdditionalList[0].additionConfigId = 488
  // row.platformOrderDeliveryAdditionalList[0].ingredientsSku = "OPS22062304000009"
  deliveryAdditionalList.value = row.platformOrderDeliveryAdditionalList
  showAdt.value = true
}
// 表格下单编辑附加项
const editSendAddition = (e: any) => {
  editDeliveryAdditionsApi({
    platformOrderId: waitOrderItem.platformOrderId,
    deliveryAdditionalList: e.map((i: any) => {
      return {
        additionConfigId: i.additionConfigId,
        ingredientsSku: i.ingredientsSku === '-' ? '' : i.ingredientsSku,
        additionExtraName: i.additionNameJp
      }
    })
  }).then((res: any) => {
    if (res.success) {
      refreshTable(true)
    }
  })
}
// 表格下单编辑国际物流
const changeLogistics = async (row: any, expressItem: any) => {
  const resData = await editIntShipApi({
    platformOrderId: row.platformOrderId,
    intShipConfigId: expressItem.intShipConfigId,
    intForwarderConfigId: expressItem?.forwarders?.[0]?.intForwarderConfigId
  })
  if (resData.success) {
    ElMessage.success(t('修改成功'))
    refreshTable(true)
    return true
  } else {
    return false
  }
}
const additionVisible = ref(false)
const goodsAdditionList: any = ref(null)
const additionCountryCode = ref('CN')
const orderItem: any = ref({})
const goodsRowItem: any = ref({}) //
const choiceCost = ref(false)
const openAddition = (row: any, order: any) => {
  choiceCost.value = order.tags?.includes(4)
  goodsRowItem.value = {
    ...row,
    platformOrderItemAdditionDTOList: (row.platformOrderItemAdditionDTOList === '-' ? [] : row.platformOrderItemAdditionDTOList ?? [])?.map((item: any) => {
      return {
        ...item,
        washedlabelSpecification:
          item.washedlabelSpecification === '-'
            ? ''
            : item.washedlabelSpecification,
        spotCheckRatio: item.spotCheckRatio && item.spotCheckRatio !== '-' ? item.spotCheckRatio : ''
      }
    })
  }
  orderItem.value = order
  goodsAdditionList.value = row.platformOrderItemAdditionDTOList === '-' ? [] : row.platformOrderItemAdditionDTOList.map((item: any) => {
    return {
      ...item,
      washedlabelSpecification: item.washedlabelSpecification === '-' ? '' : item.washedlabelSpecification
    }
  })
  additionCountryCode.value = row.goodsCountry
  additionVisible.value = true
}
const noReset = ref(false)
const handleAdt = (adt: any) => {
  editOrderGoodsAdditionApi({
    platformOrderId: orderItem.value?.platformOrderId,
    platformOrderItemIdList: [goodsRowItem.value.platformOrderItemId],
    cartAdditionList:
      adt === 1
        ? []
        : adt.map((i: any) => {
          return {
            shopProductSku: goodsRowItem.value.shopProductSku,
            additionConfigId: i.additionConfigId,
            additionId: i.additionId,
            ingredientsSku: i.ingredientsSku === '-' ? '' : i.ingredientsSku,
            additionExtraName: i.additionExtraName,
            washedlabelAdditionId:
              i.washedlabelAdditionId === '-' ? '' : i.washedlabelAdditionId,
            washedlabelSpecification:
              i.washedlabelSpecification === '-'
                ? ''
                : i.washedlabelSpecification,
            spotCheckRatio: i.spotCheckRatio && i.spotCheckRatio !== '-' ? i.spotCheckRatio : '',
            spotCheckFlag: i.spotCheckFlag
          }
        }),
    noAdditionalFlag: adt === 1 ? 1 : 0
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      SChildTableRefs.value[orderItem.value?.platformOrderId].getData()
      getPlatformOrder({
        platformOrderNoList: [orderItem.value.platformOrderNo],
        customerShopId: store.getters.curShop
      }).then((result: any) => {
        noReset.value = true
        const item = result.data.records?.[0]
        const index = STableRef.value.tableData.findIndex(v => v.platformOrderNo === orderItem.value.platformOrderNo)
        if (index === -1) return
        STableRef.value.tableData[index].productAdditionFreezeAmount = item.productAdditionFreezeAmount
        STableRef.value.tableData[index].totalFreezeAmount = item.totalFreezeAmount
      })
      // refreshTable(true)
    }
  })
}
const orderNumObj: any = ref({
  allCount: 0,
  waitPayCount: 0,
  dealingCount: 0,
  canDeliverCount: 0,
  partDeliverCount: 0,
  completeCount: 0
})
const tabList = computed(() => {
  const list = JSON.parse(
    JSON.stringify(isD2C() ? d2cOrderTabs : b2bOrderTabs)
  )
  // list.forEach((item:any) => {
  //   if (item.name === 'all') {
  //     item.title += orderNumObj.value.allCount > 0 ? `(${orderNumObj.value.allCount})` : ''
  //   }
  //   if (item.name === '2') {
  //     item.title += orderNumObj.value.waitPayCount > 0 ? `(${orderNumObj.value.waitPayCount})` : ''
  //   }
  //   if (item.name === '4') {
  //     item.title += orderNumObj.value.dealingCount > 0 ? `(${orderNumObj.value.dealingCount})` : ''
  //   }
  //   if (item.name === '8') {
  //     item.title += orderNumObj.value.canDeliverCount > 0 ? `(${orderNumObj.value.canDeliverCount})` : ''
  //   }
  //   if (item.name === '16') {
  //     item.title += orderNumObj.value.partDeliverCount > 0 ? `(${orderNumObj.value.partDeliverCount})` : ''
  //   }
  //   if (item.name === '32') {
  //     item.title += orderNumObj.value.completeCount > 0 ? `(${orderNumObj.value.completeCount})` : ''
  //   }
  // })
  return list
})
const setOrderNum = () => {
  getEveryOrderNumberApi({}).then((res: any) => {
    if (res.success) {
      orderNumObj.value = res.data
    }
  })
}
setOrderNum()
const uploadFailVisible = ref(false)
const failInfo = ref({})
searchUploadProgressApi({
  taskType: 1
}).then((res: any) => {
  const { knowFlag, taskStatus } = res.data
  if (taskStatus === 3 && knowFlag === 1) {
    // 导入失败 && 未知晓
    uploadFailVisible.value = true
    failInfo.value = res.data
  }
})

const drawerDocumentaryRecordRef = ref()

const openExpress = (info: any, row: any, status: number) => {
  drawerDocumentaryRecordRef.value.open({
    info: info,
    row,
    status
  })
}
const isStoreApi = computed(
  () => store.getters.shopInfo?.customerShopPlatform === 3
)
const isShopify = ref(false)
isShowShopifyTitleApi().then((res: any) => {
  isShopify.value = res.data?.isSubscription || isStoreApi.value
})
const jumpAbnormalOrder = (
  row: any,
  type: string,
  status: any,
  scope?: any
) => {
  const query = {
    customerOperateStatus: status,
    platformOrderNo: row.platformOrderNo || scope.platformOrderNo,
    productSku: row.productSku
  }
  router.push(useRtfix('AbnormalOrder', { query }))
}
/** 分期支付信息确认 */
const partPayVisible = ref(false)
const partPayLoading = ref(false)
/** 余额不足弹窗 */
const balanceVisible = ref(false)
/** 打开分期付款支付信息弹窗 */
const openConfirmPartPayInfo = (row: any) => {
  partPayVisible.value = true
  rowItem.value = row
}
// 分期付款
const handlePartPay = async () => {
  /**
          enum FREEZE_STATUS { // freezeStatus
          '未冻结' = 1,
          '冻结中' = 2,
          '冻结成功' = 3,
          '冻结失败' = 4
          }

          enum PURCHASE_APPLY { // purchaseApplyFlag
            '未发起' = false,
            '已发起' = true,
          }
         */
  try {
    /** 找到需支付的账期序号：stageNo */
    const obj = rowItem.value.stageInfos.find((item: any) => {
      return [1, 4].includes(item.freezeStatus) && item.purchaseApplyFlag
    })
    partPayLoading.value = true
    const res = await partPayApi({
      customerShopId: store.getters.curShop,
      platformOrderNo: rowItem.value.platformOrderNo,
      stageNo: obj.stageNo
    })
    const row = rowItem.value

    // 订单信息查询
    const res1 = await getPlatformOrderDetail({
      platformOrderId: row.platformOrderId
    })
    const OrderProductDetailList: any = []
    if (res1.success) {
      res1.data?.platformOrderItemList?.forEach((j: any) => {
        OrderProductDetailList.push({
          product_num: j.orderQuantity,
          product_title_ja: j.productTitleJp,
          product_code: j.productCode
        })
      })
    }
    if (res.success) {
      // TODO:埋点
      taTrack({
        event: TaEvent.ORDER_PAY,
        value: {
          currency: 'CNY',
          order_no: row.platformOrderNo,
          pay_amount: row.totalFreezeAmount,
          pay_result: 'success',
          fail_reason: '',
          order_product_detail: OrderProductDetailList
        }
      })
      ElMessage.success(t('支付成功'))
      partPayVisible.value = false
      partPayLoading.value = false
      refreshTable()
    } else {
      if (res.msg === '钱包余额不足') {
        taTrack({
          event: TaEvent.ORDER_PAY,
          value: {
            currency: 'CNY',
            order_no: row.platformOrderNo,
            pay_amount: row.totalFreezeAmount,
            pay_result: 'fail',
            fail_reason: '钱包余额不足',
            order_product_detail: OrderProductDetailList
          }
        })
        partPayLoading.value = false
        partPayVisible.value = false
        balanceVisible.value = true
      }
    }
  } catch (err) {
    partPayLoading.value = false
  }
}

// 编辑客户订单编号
const saveCustomerNo = (row: any) => {
  console.log(row)
  if (!row.customerOrderNo || row.customerOrderNo === '-') {
    return
  }
  row.loading = true
  editCustomerNoApi({
    customerOrderNo: row.customerOrderNo,
    platformOrderNo: row.platformOrderNo
  })
    .then(() => {
      row.edit = false
      nextTick(() => {
        STableRef.value && STableRef.value.getData()
      })
    })
    .finally(() => {
      row.loading = true
    })
}

// table 订单字段
const columns = computed(() => {
  const list = isD2C() ? (d2cOrderColumns.filter((i: any) => isShopify.value || i.prop !== 'orderName')) : b2bOrderColumns
  const newList = list.map((i: any) => {
    if (i.prop === 'orderName' && isD2C()) {
      i.label = t('订单') + `(${getCustomerShopPlatform()})`
    }
    return i
  }).concat((isKO() && isD2C()) ? [{
    label: t('国际物流单号'),
    prop: 'trackingNumber',
    // slotName: 'payInfoSlot',
    align: 'center',
    width: 120
  }] : [])
  // 过滤韩国仓字段
  const filterKoreaColumns = newList.filter((v: { isMultiStore: boolean }) => isMultiStore() || !v.isMultiStore)
  const filterNoTiktokColumns = filterKoreaColumns.filter(i => isD2C() ? true : i.prop !== 'wareCode')
  return filterNoTiktokColumns
})
// table 订单下商品列表字段
const childColumns = computed(() => {
  const list = isD2C() ? d2cChildColumns : b2bChildColumns
  return list
})

// 商品行金额转换，并区分过滤 商品所在地字段
const getChildColumns = (columns: any, record: any) => {
  if (record.tags.includes(4)) {
    // 一价全包table
    return d2cChoiceChildColumns
  }
  const isReplenish = record.tags?.includes(7) && record.platformOrderStatus === 2
  return columns.filter((v: { isMultiStore: boolean }) => isMultiStore() || !v.isMultiStore).map((item: any) => {
    // if (['actualProductSellPrice', 'actualTotalProductSellPrice', 'averagePrice', 'final'].includes(item.prop)) {
    //   return {
    //     ...item,
    //     label: item.label + (isMultiStoreType ? '(KRW)' : '(CNY)')
    //   }
    // }
    return item
  }).filter(v => {
    if (v.show) {
      if (isReplenish && v.show?.includes(7)) {
        return true
      }
      return false
    }
    if (v.hidden) {
      if (isReplenish && v.hidden?.includes(7)) {
        return false
      }
      return true
    }
    return true
  })
}
const getExpressData = async (item: any) => {
  const resData = await getPlatformOrderItem({
    platformOrderId: item.platformOrderId,
    source: 1
  })
  let skuList: any = []
  resData.data.forEach((v: any) => {
    if (v.productType === 3) {
      skuList = [
        ...skuList,
        ...v.combinationOrderItemList.map((temp: any) => {
          return {
            num: temp.orderQuantity,
            productSku: temp.productSku,
            productType: temp.productType
          }
        })
      ]
      return
    }
    skuList.push({
      num: v.orderQuantity,
      productSku: v.productSku,
      productType: v.productType
    })
  })
  return {
    skuList,
    countryCode:
      item.receivingCountryCode === '-' ? 'JP' : item.receivingCountryCode,
    systemSource: isD2C() ? 1 : 2
  }
}
const batchExpressList = ref({
  CN: [],
  KR: [],
  JP: []
})
const getExpress = async () => {
  // 获取物流列表
  const res = await throughCountryGetExpressApi({
    countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.CN)
  })
  if (res.success) {
    const newData = res.data.map((item: { forwarders: any[]; countryCode: any }) => {
      const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
      item.countryCode = [...new Set(countryCodeArray)].join(',')
      return item
    })
    batchExpressList.value.CN = newData
  }
  const resData = await throughCountryGetExpressApi({
    countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.KR)
  })
  if (resData.success) {
    const newData = resData.data.map((item: { forwarders: any[]; countryCode: any }) => {
      const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
      item.countryCode = [...new Set(countryCodeArray)].join(',')
      return item
    })
    batchExpressList.value.KR = newData
  }
  const resDataJP = await throughCountryGetExpressApi({
    countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.JP)
  })
  if (resDataJP.success) {
    const newData = resDataJP.data.map((item: { forwarders: any[]; countryCode: any }) => {
      const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
      item.countryCode = [...new Set(countryCodeArray)].join(',')
      return item
    })
    batchExpressList.value.JP = newData
  }
  console.log(batchExpressList.value)
}
getExpress()

const getAveragePrice = (row: any) => {
  if (row.settlePriceList?.length > 1 && (row.productType !== 3)) {
    let price = getTrueNumber(row.settlePriceList.reduce((total: number, v: any): number => {
      return total + v.price
    }, 0) / row.settlePriceList.reduce((total: number, v: any): number => {
      return total + v.num
    }, 0))
    if (row?.goodsCountry === COUNTRY.KR) {
      price = Math.ceil(price)
    }
    return showPriceAndUnit(price, showCurrentUnit(COUNTRY.KR === row.goodsCountry))
  }
  const price = row.settlePriceList?.[0]?.price
  const num = row.settlePriceList?.[0]?.num
  if (price && row.productType !== 3) {
    let p = getTrueNumber(price / num)
    if (row?.goodsCountry === COUNTRY.KR) {
      p = Math.ceil(p)
    }
    return showPriceAndUnit(p, showCurrentUnit(COUNTRY.KR === row.goodsCountry))
  }
  return '-'
}
const noAdd = (row: any, order: any) => {
  goodsRowItem.value = row
  orderItem.value = order
  additionCountryCode.value = row.goodsCountry
  handleAdt(1)
}

const getPayTitle = (row: any) => {
  if (row.tags.includes(4) && row.exchangeRate !== allIncludeExchangeRate.value) {
    return t('一口价订单汇率已更新，请确认支付')
  }
  return t('是否去支付')
}

const rechargeRef = ref()
const figurePayRef = ref()
const shopWallet = ref(0)
const getBalance = async () => {
  const wallet = await getWallet({
    customerShopId: store.getters.curShop,
    currencyCode: 'CNY'
  }).then((res) => res.data.availableAmount)
  shopWallet.value = wallet
  return wallet
}
getBalance()
const paySuccess = async () => {
  await getBalance()
  toPay(payRow.value)
}
const payGoodsList: any = ref([])
const choiceTotalAmount = computed(() => {
  console.log('tableData.value', tableData.value)
  const list = payGoodsList.value
  return {
    // 商品代金
    productResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeProductPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeProductPrice ?? 0)
      }, 0)
    },
    // 手续费
    defaultAdditionResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.defaultAdditionPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.defaultAdditionPrice ?? 0)
      }, 0)
    },
    // 商品附加项
    productAdditionResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeProductPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeProductPrice ?? 0)
      }, 0)
    },
    // 国际运费
    internalShipResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeShipPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeShipPrice ?? 0)
      }, 0)
    },
    // 关税
    allIncludeTaxResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeTaxPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeTaxPrice ?? 0)
      }, 0)
    },
    totalAmt: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPriceExchange ?? 0)
    }, 0),
    totalAmtCn: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPrice ?? 0)
    }, 0),
    totalPriceCNY: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPrice ?? 0)
    }, 0),
    totalPriceJPY: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPriceExchange ?? 0)
    }, 0),
    totalQuantity: list.reduce((total: number, v: any): number => {
      return total + (v.orderQuantity ?? 0)
    }, 0)
  }
})

const changeTransportType = (platformOrderId: string, type: number) => {
  editTransportTypeApi({
    platformOrderId: platformOrderId,
    transportType: type
  }).then(({ success }: any) => {
    if (success) {
      nextTick(() => {
        STableRef.value && STableRef.value.getData()
      })
    }
  })
}

const changeRecommendReplenishQuantity = async (row: any, order:any) => {
  if (!row?.orderQuantity || isNaN(row?.orderQuantity)) {
    row.orderQuantity = row?.oldOrderQuantity
  } else {
    const res = await request.order.customer.platformOrderEditRecommendReplenishQuantity({
      platformOrderItemId: row.platformOrderItemId,
      recommendReplenishQuantity: row.orderQuantity
    })
    if (res.success) {
      ElMessage.success(t('修改成功'))
    }
    nextTick(() => {

      SChildTableRefs.value?.[row.platformOrderId]?.getData()
      getPlatformOrder({
        platformOrderNoList: [order.platformOrderNo],
        customerShopId: store.getters.curShop
      }).then((result: any) => {
        noReset.value = true
        const item = result.data.records?.[0]
        const index = STableRef.value.tableData.findIndex(v => v.platformOrderNo === order.platformOrderNo)
        if (index === -1) return
        STableRef.value.tableData[index].productAdditionFreezeAmount = item.productAdditionFreezeAmount
        STableRef.value.tableData[index].totalFreezeAmount = item.totalFreezeAmount
      })
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommonTip, {
      name: _unref(isD2C)() ? 'stopPurchaseOrder,stopWarehouse' : 'stopPurchaseOrder'
    }, null, 8, ["name"]),
    _createElementVNode("div", {
      class: _normalizeClass(["order-list", 'order-list-' + _unref(useSite)()])
    }, [
      (orderNumObj.value?.waitPayCount > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(orderNumObj.value.waitPayCount > 99 ? '99+' : orderNumObj.value.waitPayCount), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_el_tabs, {
        modelValue: _unref(tabData),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabData) ? (tabData).value = $event : null)),
        type: "card",
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabList), (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.name,
              label: item.title,
              name: item.name
            }, null, 8, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(SSearch, {
        form: _unref(orderForm),
        "onUpdate:form": [
          _cache[1] || (_cache[1] = ($event: any) => (_isRef(orderForm) ? (orderForm).value = $event : null)),
          search
        ],
        isTiktok: _unref(isTiktok),
        states: _unref(platformOrderStatus),
        isShopify: isShopify.value
      }, null, 8, ["form", "isTiktok", "states", "isShopify"]),
      _createElementVNode("div", _hoisted_2, [
        (_unref(tabData) !== '2')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (exportOrder(1))),
              loading: exportLoading.value,
              style: {"margin":"25px 30px 25px 14px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('导出订单')) + " ", 1),
                (_unref(exportNum))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_unref(exportNum)) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: batchPay,
              style: {"margin":"25px 30px 25px 14px"},
              disabled: _unref(selectedOrderList).length === 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('批量付款')) + " ", 1),
                (_unref(selectedOrderList).length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_unref(selectedOrderList).length) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"])),
        (_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              onClick: batchPriorityDelivery,
              style: {"margin":"25px 30px 25px 14px"},
              disabled: _unref(selectedOrderList).length === 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  placement: "top",
                  effect: "light",
                  "hide-after": 30
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('请将优先发货筛选项改为是后操作1')), 1)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('批量优先发货')), 1),
                (_unref(selectedOrderList).length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(" + _toDisplayString(_unref(selectedOrderList).length) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_unref(tabData) !== '2' && _unref(is3RDCustomerShop)())
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (exportOrder(2))),
              loading: exportLoading.value,
              style: {"margin":"25px 30px 25px 14px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('API订单导出')), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            _isRef(STableRef) && (STableRef.value = _value)
          },
          "page-data": _unref(pageData),
          "onUpdate:page-data": _cache[7] || (_cache[7] = ($event: any) => (_isRef(pageData) ? (pageData).value = $event : null)),
          api: _unref(getPlatformOrder),
          filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
          columns: _unref(columns),
          tableConfig: parentTableConfig,
          "row-class-name": orderClassName,
          onSelectionChange: _unref(handleSelectionChange),
          onExpandRow: _unref(handleExpandRow),
          onExpandAll: _unref(handleExpandAll),
          onDataListener: dataListenerFn,
          showTableFilter: true,
          defaultFilterKey: "orderList"
        }, {
          platformOrderSettleStatusHead: _withCtx(() => [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_unref(t)('订单是否结算')) + " ", 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('当商品状态更改为“已检”和“已取消”，则会清算指定的商品金额，订单的所有商品状态更改为“已清算”，则订单清算完成')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ]),
          wareCode: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.wareCode === _unref(jpWareInfo).warehouseCode ? _unref(t)('日本') : _unref(t)('中国')), 1)
          ]),
          payInfoSlot: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (row.totalSettleAmount !== null && row.totalSettleAmount !== '-')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_unref(t)('结算金额')) + " ", 1),
                        _createVNode(_component_el_tooltip, {
                          effect: "light",
                          placement: "top",
                          "popper-class": "tool-tip-no-border"
                        }, {
                          content: _withCtx(() => [
                            (!row.tags.includes(4))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createTextVNode(_toDisplayString(_unref(t)('结算金额')) + " = " + _toDisplayString(_unref(t)('商品金额')) + " + " + _toDisplayString(_unref(t)('商品附加项费用')) + " + " + _toDisplayString(_unref(t)('国内运费')) + " + " + _toDisplayString(_unref(t)('代购手续费')) + " ", 1),
                                  (row.platformOrderType == '1')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " + " + _toDisplayString(_unref(isTiktok) && row.platformOrderType === 1 && row.wareCode === _unref(jpWareInfo).warehouseCode ?
                            '日本国内送料' : _unref(t)('国际运费')), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)('合计额（清算后）=实际清算数量*全包单价')), 1))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionFilled), { style: {"height":"14px","transform":"translateY(3px)"} })
                          ]),
                          _: 2
                        }, 1024),
                        _hoisted_18
                      ]),
                      ((row.platformOrderType == '1' && row.wareCode == _unref(jpWareInfo).warehouseCode))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(row.totalSettleAmount) + "円", 1))
                        : (row.tags.includes(4))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(row.totalSettleAmountJpy) + "円(" + _toDisplayString(row.totalSettleAmount) + "元)", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(showPriceAndUnit)(row.totalSettleAmount ??
                    '-',
                    _unref(showCurrentUnit)(_unref(COUNTRY).KR ===
                      row.deliveryCountry))), 1))
                    ]))
                  : (row.totalFreezeAmount !== '-')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (row.tags.includes(4))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('交易金额')) + "：", 1),
                              _createElementVNode("span", null, _toDisplayString(row.totalFreezeAmountJpy) + "円(" + _toDisplayString(row.totalFreezeAmount) + "元)", 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('冻结金额')) + "：", 1),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(showPriceAndUnit)(row.totalFreezeAmount, _unref(showCurrentUnit)(_unref(COUNTRY).KR
                    ===
                    row.deliveryCountry))), 1),
                              (row.productAdditionFreezeAmount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('商品附加项费用')) + "：", 1),
                                    _createElementVNode("span", null, _toDisplayString(_unref(showPriceAndUnit)(row.productAdditionFreezeAmount, _unref(showCurrentUnit)(_unref(COUNTRY).KR ===
                      row.deliveryCountry))), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (row.stageInfos.length && row.stageInfos !== '-')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.stageInfos, (item) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "pay-info-list",
                                        key: item.stageNo
                                      }, [
                                        _createElementVNode("div", _hoisted_28, [
                                          _createElementVNode("div", null, [
                                            (item.stageNo)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(t)('X期金额').replace('X',
                            `${item.stageNo}/${row.stageInfos.length} `)) + "(" + _toDisplayString(item.freezeRate) + ")", 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(item.freezeStatus === 2 ? 'font-red' : '')
                                            }, _toDisplayString(_unref(showPriceAndUnit)(item.freezeAmount?.toFixed(2),
                              _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.deliveryCountry))), 3)
                                          ]),
                                          _createElementVNode("div", null, [
                                            (item.freezeStatus === 3)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(t)('已支付')), 1))
                                              : _createCommentVNode("", true),
                                            (item.freezeStatus === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(t)('本期支付')), 1))
                                              : _createCommentVNode("", true),
                                            ([1, 4].includes(item.freezeStatus))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(t)('待支付')), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]))
                    : _createCommentVNode("", true)
              ])
            ])
          ]),
          expand: _withCtx(({ scope }) => [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(STable, {
                "max-height": "400px",
                class: "productTable",
                ref: (el) => _unref(SChildTableRefs)[scope.row.platformOrderId] = el,
                "page-data": scope.row._pageData,
                "onUpdate:page-data": ($event: any) => ((scope.row._pageData) = $event),
                api: _unref(getPlatformOrderItemPage),
                filterData: { platformOrderId: scope.row.platformOrderId, source: 1 },
                page_position: "left",
                columns: getChildColumns(_unref(childColumns), scope.row),
                tableConfig: _unref(childConfig),
                isImmediatelyExec: false,
                onDataListener: ($event: any) => (_unref(toggleExpandAllChange)(scope.row))
              }, {
                settleStatus: _withCtx(({ row }) => [
                  (row.virtualFlag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, " - "))
                    : ([1, 2].includes(row.settleStatus))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_unref(t)('未结算')), 1))
                      : (row.settleStatus === 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_unref(t)('已结算')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
                ]),
                abnormalSlot: _withCtx(({ row }) => [
                  (row?.untreatedNum > 0 || row?.processedNum > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        (row?.untreatedNum > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "abnormal-jump",
                              onClick: _withModifiers(($event: any) => (jumpAbnormalOrder(row, 'goods', 1, scope.row)), ["stop"])
                            }, _toDisplayString(_unref(t)('未处理')) + "（" + _toDisplayString(row.untreatedNum) + "）>", 9, _hoisted_39))
                          : _createCommentVNode("", true),
                        _hoisted_40,
                        (row?.processedNum > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "abnormal-jump",
                              onClick: _withModifiers(($event: any) => (jumpAbnormalOrder(row, 'goods', 0, scope.row)), ["stop"])
                            }, _toDisplayString(_unref(t)('已处理')) + "（" + _toDisplayString(row.processedNum) + "）>", 9, _hoisted_41))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, "-"))
                ]),
                purchaseCountry: _withCtx(({ row }) => [
                  (row.productType != 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(countryCodeNameMap).get(row.purchaseCountry)), 1))
                    : _createCommentVNode("", true)
                ]),
                actualProductSellPrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1)
                ]),
                actualTotalProductSellPrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualTotalProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR ===
                    row.goodsCountry))), 1)
                ]),
                expand: _withCtx(({ scope: scopeChild }) => [
                  _createVNode(STable, {
                    class: "combinationTable",
                    "table-data": scopeChild.row.combinationOrderItemList,
                    columns: getChildColumns(_unref(childColumns), scope.row),
                    tableConfig: _unref(childConfig),
                    showPagination: false,
                    onRowClick: (row) => { row.productType !== 3 && jump(_unref(useRtfix)('ProductInfo', { query: { platformOrderItemId: row.platformOrderItemId, productType: row.productType, isGroup: scopeChild.row.productType === 3, combineSku: scope.row.separateFlag === 0 ? scopeChild.row.productSku : '' } })) }
                  }, {
                    abnormalSlot: _withCtx(({ row }) => [
                      (row?.untreatedNum > 0 || row?.processedNum > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            (row?.untreatedNum > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "abnormal-jump",
                                  onClick: _withModifiers(($event: any) => (
                        jumpAbnormalOrder(row, 'goods', 1, scope.row)
                        ), ["stop"])
                                }, _toDisplayString(_unref(t)('未处理')) + "（" + _toDisplayString(row.untreatedNum) + "）>", 9, _hoisted_45))
                              : _createCommentVNode("", true),
                            _hoisted_46,
                            (row?.processedNum > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "abnormal-jump",
                                  onClick: _withModifiers(($event: any) => (
                        jumpAbnormalOrder(row, 'goods', 0, scope.row)
                        ), ["stop"])
                                }, _toDisplayString(_unref(t)('已处理')) + "（" + _toDisplayString(row.processedNum) + "）>", 9, _hoisted_47))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48, "-"))
                    ]),
                    purchaseCountry: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.purchaseCountry)), 1)
                    ]),
                    settleStatus: _withCtx(({ row }) => [
                      (row.virtualFlag)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, " - "))
                        : ([1, 2].includes(row.settleStatus))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_unref(t)('未结算')), 1))
                          : (row.settleStatus === 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_unref(t)('已结算')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_52, "-"))
                    ]),
                    shoppingInfo: _withCtx(({ row }) => [
                      _createElementVNode("div", {
                        class: "flex-ter",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createVNode(GoodsLink, {
                          goods: row,
                          class: "fx-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ShoppingPreview, {
                              image: getImage(
                          row.productSkuImg || row.productMainImg || ''
                        )
                          ,
                              name: row.productTitleJp || ''
                            }, null, 8, ["image", "name"])
                          ]),
                          _: 2
                        }, 1032, ["goods"])
                      ])
                    ]),
                    productSku: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_el_tooltip, {
                            content: _unref(t)(
                          'クリックすると、商品の作業履歴をご確認いただけます！'
                        )
                          ,
                            placement: "top",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              row
                                ? (_openBlock(), _createBlock(ProductSku, {
                                    key: 0,
                                    row: row,
                                    productType: row.productType,
                                    isGroup: scopeChild.row.productType === 3,
                                    combineSku: scope.row.separateFlag === 0
                              ? scopeChild.row.productSku
                              : ''
                              
                                  }, null, 8, ["row", "productType", "isGroup", "combineSku"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ]),
                        _createVNode(CopyButton, {
                          text: row.productSku
                        }, null, 8, ["text"])
                      ])
                    ]),
                    averagePrice: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(getAveragePrice(row)), 1)
                    ]),
                    final: _withCtx(({ row }) => [
                      (row.settlePriceList?.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList.reduce(
                          (total, v): number => {
                            return total + v.price
                          },
                          0
                        ), _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1))
                        : _createCommentVNode("", true),
                      (row.settlePriceList?.length > 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _withModifiers(($event: any) => (checkFinalPrice(row)), ["stop"]),
                            style: {"color":"#1890ff","cursor":"pointer"}
                          }, _toDisplayString(_unref(t)('查看详情')), 9, _hoisted_56))
                        : (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList?.[0]?.price
                          ? row.settlePriceList?.[0]?.price
                          : '-', _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1))
                    ]),
                    finalHead: _withCtx(() => [
                      _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(t)('最终采购价')), 1)
                    ]),
                    productPropertiesName: _withCtx(({ row }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(
                      ';'
                    ), (prop) => {
                        return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                      }), 128))
                    ]),
                    shoppingStats: _withCtx(({ row }) => [
                      row
                        ? (_openBlock(), _createBlock(ProductStats, {
                            key: 0,
                            row: row,
                            cancelJump: true,
                            orderNo: scope.row.platformOrderNo,
                            combineSku: scope.row.separateFlag === 0
                        ? scopeChild.row.productSku
                        : ''
                        ,
                            isReplenish: row.smartReplenishFlag
                          }, null, 8, ["row", "orderNo", "combineSku", "isReplenish"]))
                        : _createCommentVNode("", true)
                    ]),
                    channel: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_59, [
                        (row.productType === 3)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_unref(t)('组合')), 1)
                            ], 64))
                          : (row.productType === 2)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_unref(t)('OEM')), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(_unref(channelEnum)[row.channel] || '-'), 1)
                              ], 64))
                      ])
                    ]),
                    platformOrderItemAdditionDTOList: _withCtx(({ row }) => [
                      (
                      row.platformOrderItemAdditionDTOList &&
                      row.platformOrderItemAdditionDTOList !== '-'
                    )
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            effect: "light",
                            placement: "top"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(montageAddition)(
                              row.platformOrderItemAdditionDTOList
                            )), 1)
                            ]),
                            default: _withCtx(() => [
                              (row.platformOrderItemAdditionDTOList !== '-')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("span", _hoisted_62, "-")),
                      (
                      scope.row.orderSource === 6 &&
                      _unref(tabData) === '2' &&
                      row.productType === 1
                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createElementVNode("a", {
                              onClick: _withModifiers(($event: any) => (openAddition(row, scope.row)), ["stop"])
                            }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_64)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    goodsCountry: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.goodsCountry)), 1)
                    ]),
                    actualProductSellPrice: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1)
                    ]),
                    actualTotalProductSellPrice: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualTotalProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR ===
                        row.goodsCountry))), 1)
                    ]),
                    _: 2
                  }, 1032, ["table-data", "columns", "tableConfig", "onRowClick"])
                ]),
                platformOrderItemAdditionDTOList: _withCtx(({ row }) => [
                  (
                  row.platformOrderItemAdditionDTOList &&
                  row.platformOrderItemAdditionDTOList !== '-'
                )
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "light",
                        placement: "top"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_66, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createElementBlock("span", _hoisted_67, "-")),
                  (
                  (scope.row.orderSource === 6 || scope.row.orderSource === 10 || scope.row.tags.includes(7)) &&
                  scope.row.platformOrderStatus === 2 &&
                  row.productType === 1
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _withDirectives(_createVNode(_component_el_radio, {
                          "model-value": row.noAdditionalFlag === 1,
                          size: "small",
                          label: true,
                          style: {"margin-right":"0"},
                          onClick: _cache[5] || (_cache[5] = _withModifiers(() => { }, ["stop"])),
                          onChange: ($event: any) => (noAdd(row, scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                          ]),
                          _: 2
                        }, 1032, ["model-value", "onChange"]), [
                          [_vShow, !row.platformOrderItemAdditionDTOList?.length || row.platformOrderItemAdditionDTOList === '-']
                        ]),
                        _createElementVNode("a", {
                          onClick: _withModifiers(($event: any) => (openAddition(row, scope.row)), ["stop"])
                        }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_69),
                        _withDirectives(_createElementVNode("div", { class: "add-valid-text" }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                          [_vShow, (row.platformOrderItemAdditionDTOList === '-' && row.noAdditionalFlag !== 1)]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (scope.row.tags?.includes(7) && scope.row.platformOrderStatus === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _createVNode(_unref(Warning), { class: "icon" }),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('商品附加项是取店铺默认配置，请重新确认是否调整')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                shoppingInfo: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_71, [
                    (row.productType !== 3)
                      ? (_openBlock(), _createBlock(GoodsLink, {
                          key: 0,
                          goods: row
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ShoppingPreview, {
                              image: getImage(row.productSkuImg || row.productMainImg || ''),
                              name: row.productTitleJp || ''
                            }, null, 8, ["image", "name"])
                          ]),
                          _: 2
                        }, 1032, ["goods"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createVNode(ShoppingPreview, {
                            image: getImage(row.productMainImg || '')
                          }, null, 8, ["image"]),
                          _createElementVNode("p", null, _toDisplayString(row.productTitleJp), 1)
                        ])),
                    (row.productType === 3 && _unref(isD2C)())
                      ? (_openBlock(), _createElementBlock("img", _hoisted_73))
                      : _createCommentVNode("", true),
                    (row.priorityShippingStatus && _unref(isD2C)())
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 3,
                          referrerPolicy: "no-referrer",
                          src: `${imgHeader}d2c-${_unref(useSite)()}.png`,
                          style: {"margin-left":"10px","width":"50px"},
                          class: "order-tag"
                        }, null, 8, _hoisted_74))
                      : _createCommentVNode("", true),
                    (row.productType === 3 && !_unref(isD2C)())
                      ? (_openBlock(), _createElementBlock("img", _hoisted_75))
                      : _createCommentVNode("", true),
                    (row.priorityShippingStatus && !_unref(isD2C)())
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 5,
                          referrerPolicy: "no-referrer",
                          src: `${imgHeader}b2b-${_unref(useSite)()}.png`,
                          style: {"margin-left":"10px","width":"50px"},
                          class: "order-tag"
                        }, null, 8, _hoisted_76))
                      : _createCommentVNode("", true)
                  ])
                ]),
                productSku: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      (row.productType !== 3)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            content: _unref(t)('クリックすると、商品の作業履歴をご確認いただけます！'),
                            placement: "top",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              row
                                ? (_openBlock(), _createBlock(ProductSku, {
                                    key: 0,
                                    row: row,
                                    productType: row.productType,
                                    tooltip: true
                                  }, null, 8, ["row", "productType"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["content"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            row
                              ? (_openBlock(), _createBlock(ProductSku, {
                                  key: 0,
                                  row: row,
                                  productType: row.productType,
                                  tooltip: true
                                }, null, 8, ["row", "productType"]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]),
                    _createVNode(CopyButton, {
                      text: row.productSku
                    }, null, 8, ["text"])
                  ])
                ]),
                averagePrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(getAveragePrice(row)), 1)
                ]),
                final: _withCtx(({ row }) => [
                  (row.settlePriceList?.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList.reduce((total, v): number => {
                    return _unref(getTrueNumber)(total + v.price)
                  }, 0), _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1))
                    : _createCommentVNode("", true),
                  (row.settlePriceList?.length > 1 && (row.productType !== 3))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _withModifiers(($event: any) => (checkFinalPrice(row)), ["stop"]),
                        style: {"color":"#1890FF","cursor":"pointer"}
                      }, _toDisplayString(_unref(t)('查看详情')), 9, _hoisted_80))
                    : (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList?.[0]?.price && (row.productType !== 3) ?
                  row.settlePriceList?.[0]?.price : '-', _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1))
                ]),
                finalHead: _withCtx(() => [
                  _createElementVNode("div", _hoisted_82, _toDisplayString(_unref(t)('最终采购价')), 1)
                ]),
                productPropertiesName: _withCtx(({ row }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                    return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                  }), 128))
                ]),
                shoppingStats: _withCtx(({ row }) => [
                  (row.virtualFlag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_83, " - "))
                    : (row.productType === 3)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "text",
                          onClick: _withModifiers(($event: any) => (openCombinationVisible(row)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          row
                            ? (_openBlock(), _createBlock(DocumentaryRecord, {
                                key: 0,
                                row: row,
                                cancelJump: true,
                                orderNo: scope.row.platformOrderNo,
                                showExpress: true,
                                onOpen: openExpress,
                                isReplenish: row.smartReplenishFlag
                              }, null, 8, ["row", "orderNo", "isReplenish"]))
                            : _createCommentVNode("", true)
                        ], 64))
                ]),
                channel: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_84, [
                    (row.productType === 3)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(t)('组合')), 1)
                        ], 64))
                      : (row.productType === 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(t)('OEM')), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_unref(channelEnum)[row.channel] || '-'), 1)
                          ], 64))
                  ])
                ]),
                cancelProgress: _withCtx(({ row }) => [
                  (row.cancelProgress === 1 || row.cancelProgress === 2)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (jumpCancel(row, scope.row)), ["stop"])
                      }, _toDisplayString(_unref(t)('取消成功')), 9, _hoisted_85))
                    : (_openBlock(), _createElementBlock("span", _hoisted_86, "-"))
                ]),
                feeInfo: _withCtx(({ row }) => [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (_ctx.$router.push(_unref(useRtfix)('StoreFund', { query: { platformOrderNo: scope.row.platformOrderNo, currencyCode: row.currencyCode } }))), ["stop"])
                  }, _toDisplayString(_unref(t)('查看')), 9, _hoisted_87)
                ]),
                purchasingFee: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(row.purchasingFee === '-' ? row.stallHandlingFee : row.purchasingFee), 1)
                ]),
                allIncludeProductPrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(`${row.allIncludePriceResultDetail?.allIncludeProductPriceExchange}円(${row.allIncludePriceResultDetail?.allIncludeProductPrice}元)`), 1),
                  _createVNode(AllPriceDetail, {
                    detail: row.allIncludePriceResultDetail,
                    season: row.season,
                    transportType: scope.row.transportType
                  }, null, 8, ["detail", "season", "transportType"])
                ]),
                allIncludeProductTotalPrice: _withCtx(({ row }) => [
                  (scope.row.platformOrderSettleStatus === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(`${(row.allIncludePriceResultDetail?.allIncludeProductPriceExchange *
                    row.settlementQuantity).toFixed(0)}円(${(row.allIncludePriceResultDetail?.allIncludeProductPrice *
                      row.settlementQuantity).toFixed(2)}元)`), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_89, "-"))
                ]),
                feeDetail: _withCtx(({ row }) => [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('StoreFund', { query: { platformOrderNo: scope.row.platformOrderNo } })))
                  }, _toDisplayString(_unref(t)('查看资金流水')), 9, _hoisted_90)
                ]),
                quantity: _withCtx(({ row }) => [
                  (scope.row.platformOrderStatus === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                        _createVNode(_component_el_input_number, {
                          precision: 0,
                          min: 0,
                          size: "small",
                          modelValue: row.orderQuantity,
                          "onUpdate:modelValue": ($event: any) => ((row.orderQuantity) = $event),
                          onBlur: ($event: any) => (changeRecommendReplenishQuantity(row, scope.row))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(row.orderQuantity), 1))
                ]),
                _: 2
              }, 1032, ["page-data", "onUpdate:page-data", "api", "filterData", "columns", "tableConfig", "onDataListener"])
            ])
          ]),
          platformOrderDeliveryAdditionalList: _withCtx(({ row }) => [
            (row.platformOrderDeliveryAdditionalList && row.platformOrderDeliveryAdditionalList !== '-')
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "light",
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_93, _toDisplayString(row.platformOrderDeliveryAdditionalList.map((v) => {
                  return v.additionNameJp
                }).join(',')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_94, _toDisplayString(row.platformOrderDeliveryAdditionalList.map((v) => {
                return v.additionNameJp
              }).join(',')), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createElementBlock("span", _hoisted_95, "-")),
            (row.orderSource === 6 && _unref(tabData) === '2')
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (openDt(row)), ["stop"])
                  }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_97)
                ]))
              : _createCommentVNode("", true)
          ]),
          platformOrderNo: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  (row.interceptFlag === 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: `https://static-s.theckb.com/BusinessMarket/icon/reserve_${_unref(useSite)()}.png`,
                        class: "interceptFlag"
                      }, null, 8, _hoisted_101))
                    : _createCommentVNode("", true),
                  (row.platformOrderId)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _withModifiers(($event: any) => (jump(_unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId }, query: { type: row.orderSource !== 1 ? 1 : '' } }))), ["stop"])
                      }, _toDisplayString(row.platformOrderNo), 9, _hoisted_102))
                    : (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(row.platformOrderNo), 1))
                ]),
                _createVNode(CopyButton, {
                  text: row.platformOrderNo
                }, null, 8, ["text"])
              ]),
              (_unref(isD2C)() && row.useOneTheWayInventoryFlag === 1)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    style: {"margin-top":"4px"},
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('在途抵用')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isD2C)() && row.tags?.includes(6))
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    style: {"margin-top":"4px"},
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_104
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (row.tags?.includes(7))
                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                    _createElementVNode("span", _hoisted_106, _toDisplayString(_unref(t)('API自动补货订单')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          customerOrderNo: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_107, [
              (!row.edit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(row.customerOrderNo), 1))
                : (_openBlock(), _createBlock(_component_el_input, {
                    key: 1,
                    modelValue: row.customerOrderNo,
                    "onUpdate:modelValue": ($event: any) => ((row.customerOrderNo) = $event),
                    maxlength: "30"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])),
              (row.customerOrderNo !== '-' && !row.edit)
                ? (_openBlock(), _createBlock(CopyButton, {
                    key: 2,
                    text: row.customerOrderNo
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ]),
            (!row.edit)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: ($event: any) => {row.customerOrderNo = row.customerOrderNo === '-' ? '' : row.customerOrderNo; row.edit = true},
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  onClick: ($event: any) => (saveCustomerNo(row)),
                  size: "small",
                  loading: row.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "loading"]))
          ]),
          orderName: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("span", null, _toDisplayString(row.orderName), 1),
              (row.orderName !== '-')
                ? (_openBlock(), _createBlock(CopyButton, {
                    key: 0,
                    text: row.orderName
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          orderSource: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(orderSourceEnum)[row.orderSource]), 1)
          ]),
          platformOrderType: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_110, _toDisplayString(row.tags.includes(4) ? (_unref(isD2C)() ? _unref(t)('直发订单(一口价)') : _unref(t)('囤货订单(一口价)')) :
            _unref(platformOrderTypeEnum)[row.platformOrderType]), 1)
          ]),
          createTime: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
          ]),
          inShippingInfo: _withCtx(({ row }) => [
            (_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                  (row.deliverStatus === 1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (international(row)), ["stop"])
                      }, _toDisplayString(_unref(t)('详情')), 9, _hoisted_112))
                    : (row.orderSource === 6 && _unref(tabData) === '2')
                      ? (_openBlock(), _createBlock(ExpressSelect, {
                          key: 1,
                          id: row.intShipConfigId,
                          "onUpdate:id": ($event: any) => ((row.intShipConfigId) = $event),
                          getData: () => getExpressData(row),
                          beforeSave: (id) => changeLogistics(row, id),
                          defaultExpress: batchExpressList.value[row.wareCountry],
                          className: 'express-select-' + row.platformOrderId,
                          countryCode: row.deliveryCountry
                        }, null, 8, ["id", "onUpdate:id", "getData", "beforeSave", "defaultExpress", "className", "countryCode"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(batchExpressList.value[row.wareCountry]?.find((v) =>
                v.intShipConfigId === row.intShipConfigId)?.distribution ?? (row.tags?.includes(4) ? row.transportType ===
                  1 ? _unref(t)('海运') : _unref(t)('空运') : '-')), 1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_114, [
                  (row.tags?.includes(4))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _createTextVNode(_toDisplayString(row.transportType === 1 ? _unref(t)('海运') : _unref(t)('空运')) + " ", 1),
                        (row.totalFreezeAmountJpy >= 150000 && row.platformOrderStatus === 2)
                          ? (_openBlock(), _createBlock(SelectTransport, {
                              key: 0,
                              transportType: row.transportType,
                              onChange: (type) => changeTransportType(row.platformOrderId, type)
                            }, null, 8, ["transportType", "onChange"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_116, "-"))
                ]))
          ]),
          handler: _withCtx(({ scope }) => [
            _createElementVNode("div", _hoisted_117, [
              (_unref(isJA)())
                ? (_openBlock(), _createBlock(EchartBtn, {
                    key: 0,
                    title: _unref(t)('THE CKB订单编号'),
                    list: echartRecordList.value,
                    metaData: _unref(metaData),
                    companyId: _unref(companyId),
                    orderNo: scope.row.platformOrderNo,
                    bizType: 1
                  }, null, 8, ["title", "list", "metaData", "companyId", "orderNo"]))
                : _createCommentVNode("", true),
              (!_unref(isD2C)())
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 1,
                    title: _unref(t)('复购'),
                    loading: scope.row.repurchaseCartLoading,
                    onClick: _withModifiers(($event: any) => (openRepurchaseCartVisible(scope.row)), ["stop"])
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true),
              (_unref(isArray)(scope.row.stageInfos) && scope.row.stageInfos.some((v) => [1, 4].includes(v.freezeStatus) && v.purchaseApplyFlag) && scope.row.platformOrderSettleStatus !== 3)
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 2,
                    title: _unref(t)('分期付款'),
                    onClick: _withModifiers(($event: any) => (openConfirmPartPayInfo(scope.row)), ["stop"])
                  }, null, 8, ["title", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_table_button, {
                title: _unref(t)('详情'),
                onClick: _withModifiers(($event: any) => (jump(_unref(useRtfix)('OrderInfo', { params: { id: scope.row.platformOrderId }, query: { type: scope.row.orderSource !== 1 ? 1 : '' } }))), ["stop"])
              }, null, 8, ["title", "onClick"]),
              (scope.row.preferDeliverFlag == 1 && scope.row.deliveryReviewFlag === 1)
                ? (_openBlock(), _createBlock(memberEventBox, {
                    key: 3,
                    icon: "member_coin",
                    "listen-variable": scope.row
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_table_button, {
                        title: _unref(t)('优先发货'),
                        loading: scope.row.deliveryPriorityLoading,
                        onClick: _withModifiers(($event: any) => (deliveryPriority(scope.row)), ["stop"])
                      }, null, 8, ["title", "loading", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["listen-variable"]))
                : _createCommentVNode("", true),
              (scope.row.orderCompositeStatus.split(',').some((v) => v < 32))
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 4,
                    title: _unref(t)('申请取消'),
                    loading: scope.row.applyCancelLoading,
                    onClick: _withModifiers(($event: any) => (applyCancel(scope.row)), ["stop"])
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("span", null, [
                _createVNode(_component_el_popconfirm, {
                  "popper-class": "pay-pop",
                  title: getPayTitle(scope.row),
                  onConfirm: ($event: any) => (toPay(scope.row))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_table_button, {
                      title: _unref(t)('去支付'),
                      loading: scope.row.payLoading,
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["title", "loading"])
                  ]),
                  _: 2
                }, 1032, ["title", "onConfirm"]),
                false
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      visible: false,
                      effect: "light",
                      placement: "bottom-end",
                      "hide-after": 0,
                      "show-after": 200,
                      ref: `memberPopver${scope.row.platformOrderId}`
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_icon, {
                                color: "#E6A23C",
                                class: "icon-style",
                                size: "14px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Warning))
                                ]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_120, _toDisplayString(_unref(t)('说明')), 1)
                            ]),
                            _createVNode(_component_el_icon, {
                              onClick: closePopver,
                              color: "#F56C6C",
                              size: "14px",
                              style: {"cursor":"pointer"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CircleClose))
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_121, [
                            (_unref(isSub))
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  innerHTML: _unref(t)('尊敬的用户，您需办理会员后，方可下单，请联系主账号办理').replace('请联系主账号办理', `<span style='font-weight:bold'>请联系主账号办理</span>`)
                                }, null, 8, _hoisted_122))
                              : (_openBlock(), _createElementBlock("p", _hoisted_123, _toDisplayString(_unref(t)('尊敬的用户，您需办理会员后，方可下单')), 1))
                          ]),
                          _createVNode(_component_router_link, {
                            to: _unref(useRtfix)('VipLevel')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, { class: "btn mt_5" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('办理会员')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_table_button, {
                          title: _unref(t)('去支付'),
                          onClick: _withModifiers(($event: any) => (toPay2(scope.row)), ["stop"])
                        }, null, 8, ["title", "onClick"]), [
                          [_vShow, !templateLevel.value]
                        ])
                      ]),
                      _: 2
                    }, 1536))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, scope.row.platformOrderStatus == 2]
              ]),
              (scope.row.afterSalesFlag === 1)
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 5,
                    title: _unref(t)('售后'),
                    loading: scope.row.afterSaleLoading,
                    onClick: _withModifiers(($event: any) => (afterSale(scope.row)), ["stop"])
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          platformOrderSettleStatus: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(settlementStatus)[row.platformOrderSettleStatus]), 1)
          ]),
          abnormalSlot: _withCtx(({ row }) => [
            _createElementVNode("div", null, [
              (row?.untreatedNum > 0 || row?.processedNum > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                    (row?.untreatedNum > 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "abnormal-jump",
                          onClick: _withModifiers(($event: any) => (jumpAbnormalOrder(row, 'order', 1)), ["stop"])
                        }, _toDisplayString(_unref(t)('未处理')) + "（" + _toDisplayString(row.untreatedNum) + "）>", 9, _hoisted_125))
                      : _createCommentVNode("", true),
                    _hoisted_126,
                    (row?.processedNum > 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "abnormal-jump",
                          onClick: _withModifiers(($event: any) => (jumpAbnormalOrder(row, 'order', 0)), ["stop"])
                        }, _toDisplayString(_unref(t)('已处理')) + "（" + _toDisplayString(row.processedNum) + "）>", 9, _hoisted_127))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_128, "-"))
            ])
          ]),
          deliveryCountry: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.deliveryCountry) ?? '-'), 1)
          ]),
          default: _withCtx(() => [
            _hoisted_129
          ]),
          _: 1
        }, 8, ["page-data", "api", "filterData", "columns", "onSelectionChange", "onExpandRow", "onExpandAll"])
      ]),
      _createVNode(ApplyCancelDialog, {
        visible: applyCancelVisible.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((applyCancelVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: refreshInfo
      }, null, 8, ["visible", "rowItem", "dataList"]),
      _createVNode(DeliveryPriorityDialog, {
        visible: deliveryPriorityVisible.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((deliveryPriorityVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: _unref(refreshTable)
      }, null, 8, ["visible", "rowItem", "dataList", "onRefresh"]),
      _createVNode(AfterSalesDialog, {
        visible: afterSaleVisible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((afterSaleVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: _unref(refreshTable)
      }, null, 8, ["visible", "rowItem", "dataList", "onRefresh"]),
      _createVNode(RepurchaseDialog, {
        visible: repurchaseCartVisible.value,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((repurchaseCartVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: _unref(refreshTable)
      }, null, 8, ["visible", "rowItem", "dataList", "onRefresh"]),
      _createVNode(BDialog, {
        title: _unref(t)('国际物流单号信息'),
        visible: inVisible.value,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((inVisible).value = $event)),
        rowItem: rowItem.value
      }, null, 8, ["title", "visible", "rowItem"]),
      _createVNode(FinalPriceDialog, {
        visible: finalStatus.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((finalStatus).value = $event)),
        finalData: finalData.value,
        currentUnit: currentUnit.value
      }, null, 8, ["visible", "finalData", "currentUnit"]),
      _createVNode(CombinationDialog, {
        visible: combinationVisible.value,
        "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((combinationVisible).value = $event)),
        rowItem: rowItem.value
      }, null, 8, ["visible", "rowItem"]),
      (!_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 1,
            name: "b2b-order-list"
          }))
        : _createCommentVNode("", true),
      (!_unref(isD2C)() && _unref(tableData).length > 0)
        ? (_openBlock(), _createBlock(Guide, {
            key: 2,
            name: "b2b-order"
          }))
        : _createCommentVNode("", true),
      (_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 3,
            name: "d2c-order-list"
          }))
        : _createCommentVNode("", true),
      (_unref(isD2C)() && _unref(tableData).length > 0)
        ? (_openBlock(), _createBlock(Guide, {
            key: 4,
            name: "d2c-order"
          }))
        : _createCommentVNode("", true),
      _createVNode(BatchSearch),
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          (showAdt.value)
            ? (_openBlock(), _createBlock(AdditionDrawer, {
                key: 0,
                cfg: deliveryAdditionalList.value,
                "onUpdate:cfg": _cache[15] || (_cache[15] = ($event: any) => ((deliveryAdditionalList).value = $event)),
                onClose: _cache[16] || (_cache[16] = ($event: any) => (showAdt.value = false)),
                reback: "",
                onSave: editSendAddition,
                type: "DeliAdt"
              }, null, 8, ["cfg"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })),
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          (goodsAdditionList.value)
            ? (_openBlock(), _createBlock(AdditionDrawer, {
                key: 0,
                list: goodsAdditionList.value,
                "onUpdate:list": _cache[17] || (_cache[17] = ($event: any) => ((goodsAdditionList).value = $event)),
                onCommit: handleAdt,
                type: "AdtOrder",
                proxy: goodsRowItem.value,
                countryCode: additionCountryCode.value,
                noSpot: goodsRowItem.value.orderQuantity === 1 || choiceCost.value,
                choiceCost: choiceCost.value
              }, null, 8, ["list", "proxy", "countryCode", "noSpot", "choiceCost"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })),
      _createVNode(UploadFail, {
        visible: uploadFailVisible.value,
        "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((uploadFailVisible).value = $event)),
        failInfo: failInfo.value
      }, null, 8, ["visible", "failInfo"]),
      _createVNode(PartPayDialog, {
        visible: partPayVisible.value,
        "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((partPayVisible).value = $event)),
        title: _unref(t)('分期付款'),
        rowItem: rowItem.value,
        onHandlePartPay: handlePartPay,
        partPayLoading: partPayLoading.value
      }, null, 8, ["visible", "title", "rowItem", "partPayLoading"]),
      _createVNode(BalanceDialog, {
        visible: balanceVisible.value,
        "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((balanceVisible).value = $event)),
        title: _unref(t)('余额不足')
      }, null, 8, ["visible", "title"])
    ], 2),
    _createVNode(DrawerDocumentaryRecord, {
      ref: (_value, _refs) => {
        _refs['drawerDocumentaryRecordRef'] = _value
        drawerDocumentaryRecordRef.value = _value
      }
    }, null, 512),
    _createVNode(NoStockModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((visible).value = $event)),
      goods: goods.value
    }, null, 8, ["visible", "goods"]),
    _createVNode(BatchDeliveryDialog, {
      ref: (_value, _refs) => {
        _refs['batchDeliveryModal'] = _value
        batchDeliveryModal.value = _value
      },
      onSuccess: confirmBatchPriorityDelivery,
      orderNum: _unref(selectedOrderList).length
    }, null, 8, ["orderNum"]),
    _createVNode(Recharge, {
      ref: (_value, _refs) => {
        _refs['rechargeRef'] = _value
        rechargeRef.value = _value
      },
      choiceTotalAmount: _unref(choiceTotalAmount),
      shopWallet: shopWallet.value,
      onSuccess: paySuccess
    }, null, 8, ["choiceTotalAmount", "shopWallet"]),
    _createVNode(CreateOrderSuccess, {
      ref: (_value, _refs) => {
        _refs['createOrderSuccessRef'] = _value
      }
    }, null, 512),
    _createVNode(UnRechargeModal),
    _createVNode(UnBalanceConfirm, {
      ref: (_value, _refs) => {
        _refs['unBalanceConfirmRef'] = _value
        unBalanceConfirmRef.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})